<div [ngSwitch]="type">
  <ng-container *ngSwitchCase="'onBoarding'">
    <div class="onboarding">
      <app-onboarding-stepper [fnAction]="fnAction"></app-onboarding-stepper>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'warning'">
    <div
      class="modal-header"
      #modal
      [class.modal-header-center]="type === 'warning'"
    >
      <span class="text-center">{{ title }}</span>
    </div>

    <div class="modal-body" *ngIf="content">
      <div
        class="font-regular"
        [class.modal-text-center]="type === 'warning'"
        [outerHTML]="content"
      ></div>
    </div>

    <div class="modal-footer" [class.modal-footer-center]="type === 'warning'">
      <button
        type="button"
        class="modal-footer--cta {{ content ? '' : 'mt-3' }}"
        (click)="closeAllModals()"
        [routerLink]="routeTo"
        *ngIf="routeTo; else elseBlock"
      >
        {{ action ? action : "Ok.Entendido" }}
      </button>

      <ng-template #elseBlock>
        <button
          type="button"
          class="modal-footer--cta {{ content ? '' : 'mt-3' }}"
          (click)="activeModal.close('done')"
        >
          {{ action ? action : "Ok.Entendido" }}
        </button>
      </ng-template>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div
      class="modal-header"
      #modal
      [class.modal-header-center]="type === 'notification'"
    >
      <h4 class="font-header text-center">{{ title }}</h4>
    </div>

    <div class="modal-body" *ngIf="content">
      <div
        class="font-regular"
        [class.modal-text-center]="type === 'notification'"
        [innerHTML]="content"
      ></div>
    </div>

    <div
      class="modal-footer"
      [class.modal-footer-center]="type === 'notification'"
    >
      <button
        type="button"
        class="modal-footer--cta {{ content ? '' : 'mt-3' }}"
        (click)="closeAllModals()"
        [routerLink]="routeTo"
        *ngIf="routeTo; else elseBlock"
      >
        {{ action ? action : "Ok.Entendido" }}
      </button>

      <ng-template #elseBlock>
        <button
          type="button"
          class="modal-footer--cta {{ content ? '' : 'mt-3' }}"
          (click)="activeModal.close('done')"
        >
          {{ action ? action : "Ok.Entendido" }}
        </button>
      </ng-template>
    </div>
  </ng-container>
</div>
